import type { MessageTemplates } from '../types/messageTemplate';
import { wrapFetch } from '../libs/fetch';

export const fetchMessageTemplates = async () => {
  return await wrapFetch<MessageTemplates>('/api/v1/message_templates/get_templates');
};

export const saveMessageTemplate = async (body: string, csrfToken: string) => {
  return await wrapFetch<string>('/api/v1/message_templates', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const updateMessageTemplate = async (id: string, body: string, csrfToken: string) => {
  return await wrapFetch<string>(`/api/v1/message_templates/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body,
    credentials: 'same-origin',
  });
};

export const deleteMessageTemplate = async (id: number, csrfToken: string) => {
  return await wrapFetch<string>(`/api/v1/message_templates/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
  });
};
